import { grey } from '../../utils/brandColors';

export default () => ({
  more: {
    color: grey[800],
    fontSize: 10,
    lineHeight: 1,
  },
});
